const ARIA_EXPANDED = 'aria-expanded';
const KEY_INGREDIENTS_SELECTOR = '[data-key-ingredients]';

const initPdpTabs = (root = document) => {
  const containers = root.querySelectorAll('[data-pdp-tabs]');

  if (!containers.length) return;

  const transformKeyIngredients = scope => {
    const keyContainers = scope.querySelectorAll(KEY_INGREDIENTS_SELECTOR);

    if (!keyContainers.length) return;

    keyContainers.forEach(keyContainer => {
      if (keyContainer.dataset.keyIngredientsProcessed === 'true') return;

      keyContainer.dataset.keyIngredientsProcessed = 'true';

      const paragraphs = keyContainer.querySelectorAll('p');

      paragraphs.forEach(p => {
        const raw = p.textContent.trim();
        if (!raw) return;

        const firstColonIndex = raw.indexOf(':');
        if (firstColonIndex === -1) return;

        const label = raw.slice(0, firstColonIndex).trim();
        const body = raw.slice(firstColonIndex + 1).trim();

        if (!label || !body) return;

        p.innerHTML = '';

        const heading = document.createElement('span');
        heading.textContent = label;
        heading.className = 'block mb-1.5 text-xs tracking-[0.18em] uppercase text-blue';

        const bodySpan = document.createElement('span');
        bodySpan.textContent = body;

        p.appendChild(heading);
        p.appendChild(bodySpan);
      });
    });
  };

  containers.forEach(container => {
    const tabButtons = container.querySelectorAll('[data-pdp-tab-trigger]');
    const tabPanels = container.querySelectorAll('[data-pdp-tab-panel]');
    const accordionTriggers = container.querySelectorAll('[data-pdp-accordion-trigger]');
    const accordionPanels = container.querySelectorAll('[data-pdp-accordion-panel]');

    if (!tabButtons.length && !accordionTriggers.length) return;

    const getFirstId = () => {
      if (tabButtons.length) {
        return tabButtons[0].dataset.pdpTabTrigger;
      }
      if (accordionTriggers.length) {
        return accordionTriggers[0].dataset.pdpAccordionTrigger;
      }
      return null;
    };

    const activateTab = id => {
      if (!id) return;

      tabButtons.forEach(button => {
        const isActive = button.dataset.pdpTabTrigger === id;
        button.classList.toggle('text-blue', isActive);
        button.classList.toggle('text-black', !isActive);
        button.classList.toggle('border-blue', isActive);
        button.classList.toggle('border-transparent', !isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');

        const icon = button.querySelector('[data-pdp-tab-icon]');
        if (icon) {
          icon.classList.toggle('hidden', !isActive);
        }
      });

      tabPanels.forEach(panel => {
        const isActive = panel.dataset.pdpTabPanel === id;
        panel.classList.toggle('hidden', !isActive);
      });
    };

    const toggleAccordion = id => {
      if (!id) return;

      accordionTriggers.forEach(trigger => {
        const isActive = trigger.dataset.pdpAccordionTrigger === id;
        const expanded = trigger.getAttribute(ARIA_EXPANDED) === 'true';

        if (isActive) {
          trigger.setAttribute(ARIA_EXPANDED, expanded ? 'false' : 'true');
        } else {
          trigger.setAttribute(ARIA_EXPANDED, 'false');
        }
      });

      accordionPanels.forEach(panel => {
        if (panel.dataset.pdpAccordionPanel === id) {
          panel.classList.toggle('hidden');
        } else {
          panel.classList.add('hidden');
        }
      });
    };

    const initialId = getFirstId();
    if (initialId) {
      activateTab(initialId);
    }

    transformKeyIngredients(container);

    tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        activateTab(button.dataset.pdpTabTrigger);
      });
    });

    accordionTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        toggleAccordion(trigger.dataset.pdpAccordionTrigger);
      });
    });
  });
};

export default initPdpTabs;

